import axios from "axios";
import React, { useState, useEffect } from "react";
import styles from "./AppBundle.module.css";
import AppCreation from "./AppCreation/AppCreation";
import BundleUpload from "./Bundleupload";
import { AppMain } from "./components/AppMain";
import { readableDate } from "./helper/dateToRedable";
import { BundleHistory } from "./components/BundleHistory";

const AppBundle = () => {
  const [apps, setApps] = useState([]);
  const [myApps, setMyapps] = useState(null);
  const [appBundles, setAppBundles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState("");
  const [updatingStatus, setUpdatingStatus] = useState({});
  const [showCreateAppModal, setShowCreateAppModal] = useState(false);
  const [showUploadBundleModal, setShowUploadBundleModal] = useState(false);
  const [activeBundle, setActiveBundle] = useState(null);

  //app selection
  const [selectedApp, setSelectedApp] = useState(null);

  //page selection
  const [currentPage, setCurrentPage] = useState(0);

  const goBack = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 0));
  };

  const goNextComponent = async () => {
    setCurrentPage(currentPage + 1);
  };

  // Fetch apps and bundles
  const fetchApps = async () => {
    try {
      const url = `${process.env.REACT_APP_URL}`;
      const response = await axios.get(`${url}/auth/getApps`, {
        withCredentials: true,
      });

      console.log(
        "Response data:",
        response.data,
        "response:",
        response.data.data
      );

      if (response.data.data.length === 0) {
        // setApps(null)
        return;
      }

      setMyapps(response.data.data);

      // console.log("Fetched apps:", response.data.data);
      // setApps(response.data.data || []);
    } catch (error) {
      console.error("Error fetching apps:", error.response);
    }
  };

  const fetchActiveBundle = async () => {
    try {
      const url = `${process.env.REACT_APP_URL}`;
      const response = await axios.get(`${url}/auth/fetchActiveBundle`, {
        withCredentials: true,
      });
      setActiveBundle(response.data.data[0]);
    } catch (error) {
      console.error("Error fetching active bundle:", error);
    }
  };

  const fetchAppBundles = async () => {
    try {
      setLoading(true);
      setFetchError("");
      const url = `${process.env.REACT_APP_URL}`;
      const response = await axios.get(`${url}/auth/fetchAppVersion`, {
        withCredentials: true,
      });
      setAppBundles(response.data.versions || response.data);
    } catch (error) {
      console.error("Error fetching app bundles:", error);
      setFetchError(
        error.response?.data?.message || "Failed to fetch app bundles"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApps();
    // fetchActiveBundle();
    // fetchAppBundles();
  }, []);

  const handleAppCreated = () => {
    fetchApps(); // Refresh apps list
    setShowCreateAppModal(false);
  };

  const handleBundleUploaded = () => {
    fetchAppBundles(); // Refresh bundles list
    fetchActiveBundle(); // Refresh active bundle
  };

  // ... rest of your existing functions (updateBundleStatus, updateBundleStage, formatFileSize, etc.)

  const BundleCard = ({ bundle, index }) => (
    <div className={styles.bundleCard}>
      {/* Your existing BundleCard JSX */}
    </div>
  );

  return (
    <div className={styles.container}>
      <div style={{display:'flex',justifyContent:'space-between'}}>
        <h2 className={styles.heading}>App Bundle Management</h2>
        {currentPage != 0 && <button
          onClick={() => goBack()}
          className={styles.uploadButton}
          style={{ marginRight: "10px", backgroundColor: "#28a745" }}
        >
          Back
        </button>}
      </div>

      {currentPage === 0 && (
        <>
          <div style={{}}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                background: "#222",
                padding: "10px",
                borderRadius: "6px",
              }}
            >
              <h2
                style={{
                  color: "white",
                }}
              >
                My Apps
              </h2>
 
            </div>
          </div>

          {myApps ? (
            <div>
              {myApps.map((item) => {
                console.log(item, "asd");
                return (
                  <div
                    className={styles.appItem}
                    style={{
                      display: "flex",
                      marginTop: 20,
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexDirection: "row",
                    }}
                    onClick={() => {
                      setSelectedApp(item);
                      setCurrentPage(1);
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <img
                        src={item.app_image_path}
                        alt="App Icon"
                        style={{ width: 80, height: 80, borderRadius: 12 }}
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginLeft: 10,
                        }}
                      >
                        <label>{item.app_id}</label>
                        <label>{item.app_name}</label>
                        <label>
                          <strong>{item.version}</strong>
                        </label>
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label>Package Id</label>
                      <label>
                        <strong>{item.package_id}</strong>
                      </label>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label>created at</label>
                      <label>{readableDate(item.updated_at)}</label>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div>
              <p>Please create an app before uploading bundles.</p>
              <div className={styles.uploadSection}>
                <button
                  onClick={() => setShowCreateAppModal(true)}
                  className={styles.uploadButton}
                  style={{ marginRight: "10px", backgroundColor: "#28a745" }}
                >
                  + Create New App
                </button>
              </div>
            </div>
          )}
        </>
      )}

      {currentPage === 1 && (
        <>
          {selectedApp && (
            <AppMain
              selectedApp={selectedApp}
              setCurrentPage={setCurrentPage}
            />
          )}

          {showCreateAppModal && (
            <AppCreation
              onAppCreated={handleAppCreated}
              onClose={() => setShowCreateAppModal(false)}
            />
          )}

          {showUploadBundleModal && (
            <BundleUpload
              apps={selectedApp}
              onBundleUploaded={handleBundleUploaded}
              onClose={() => {
                setShowUploadBundleModal(false);
              }}
            />
          )}
        </>
      )}

      {currentPage === 2 && (
        <BundleHistory apps={selectedApp} setCurrentPage={goNextComponent} />
      )}
    </div>
  );
};

export default AppBundle;
